export function excelDownload(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    var anchor = document.createElement('a');
    var blob = new Blob([content], {
        type: contentType,
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename + '.xls');
    } else {
        anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
        anchor.download = filename + '.xls';
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}


function JSONToCSV(JSONData, ReportTitle) {
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    var row = '';
    for (var index1 in arrData.sections) {
        CSV += arrData.sections[index1].name + '\r\n\n';
        CSV += arrData.sections[index1].description + '\r\n\n';

        for (var index in arrData.sections[index1].headers) {
            row += arrData.sections[index1].headers[index] + ',';
        }
        row = row.slice(0, -1);
        CSV += row + '\r\n';
        for (var i = 0; i < arrData.sections[index1].results.length; i++) {
            var row = '';
            for (var index in arrData.sections[index1].results[i]) {
                row += '"' + arrData.sections[index1].results[i][index] + '",';
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
    }
    if (CSV == '') {
        alert('Invalid data');
        return;
    }
    if (ReportTitle == 'Positions') {
        ReportTitle = 'Portfolios';
    }
    var fileName = '';
    fileName += ReportTitle.replace(/ /g, '_');

    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
    var anchor = document.createElement('a');
    anchor.href = uri;

    anchor.style = 'visibility:hidden';
    anchor.download = fileName + '.csv';

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

function createXmlHeader(arrData) {
    let headerRow = '<ss:Row>\n';
    let dataRow = '';

    for (var preRow in arrData.sections) {
        dataRow +=
            '<ss:Row>' +
            '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
            arrData.sections[preRow].name +
            '</ss:Data>' +
            '</ss:Cell>' +
            '</ss:Row>\n' +
            '<ss:Row>' +
            '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
            arrData.sections[preRow].description +
            '</ss:Data>' +
            '</ss:Cell>' +
            '</ss:Row>\n';
        for (var index in arrData.sections[preRow].headers) {
            headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
            headerRow += '    <ss:Data ss:Type="String">';
            headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
            headerRow += '  </ss:Cell >\n';
        }
    }

    headerRow += '</ss:Row>\n';
    return (
        '<?xml version="1.0"?>\n' +
        '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
        '<ss:Styles>\n' +
        '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
        '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
        '<ss:Borders>\n' +
        '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '</ss:Borders>\n' +
        '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
        '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
        '</ss:Style>\n' +
        '</ss:Styles>\n' +
        '<ss:Worksheet ss:Name="Sheet1">\n' +
        '<ss:Table>\n' +
        dataRow +
        '<ss:Row/>\n' +
        headerRow
    );
}

function createXmlFooter() {
    return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
}

export function jsonToXml(jsonObject) {
    var row;
    var col;
    var xml;
    var arrData =
        typeof jsonObject != 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = createXmlHeader(arrData);

    for (var rowData in arrData.sections) {
        for (
            var resultsLength = 0;
            resultsLength < arrData.sections[rowData].results.length;
            resultsLength++
        ) {
            xml += '<ss:Row>\n';
            for (var col in arrData.sections[rowData].results[resultsLength]) {
                xml += '  <ss:Cell>\n';
                xml += '    <ss:Data ss:Type="String">';
                xml +=
                    arrData.sections[rowData].results[resultsLength][col] +
                    '</ss:Data>\n';
                xml += '  </ss:Cell>\n';
            }
            xml += '</ss:Row>\n';
        }
    }
    xml += createXmlFooter();
    return xml;
}
export function jsonToXmlDocuCenter(jsonObject) {
    var row;
    var col;
    var xml;
    var arrData =
        typeof jsonObject != 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = createXmlHeaderDocuCenter(arrData[0]);

    for (var resultsLength = 0; resultsLength < arrData[1].length; resultsLength++) {
        var temp = arrData[1][resultsLength];

        var result = Object.keys(temp).map(function (key) {
            return [temp[key]];
        });

        xml += '<ss:Row>\n';
        for (var dataResultsLength = 0; dataResultsLength < result.length; dataResultsLength++) {
            xml += '  <ss:Cell>';
            xml += '    <ss:Data ss:Type="String">';
            xml += result[dataResultsLength][0] ? result[dataResultsLength][0] + '</ss:Data>' : '' + '</ss:Data>';
            xml += '  </ss:Cell>';
        }
        xml += '</ss:Row>\n';
    }

    xml += createXmlFooter();
    return xml;
}

function createXmlHeaderDocuCenter(dataHeader) {
    let headerRow = '<ss:Row>\n';
    let dataRow = '';


    for (var index in dataHeader) {
        headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
        headerRow += '    <ss:Data ss:Type="String">';
        headerRow += dataHeader[index] + '</ss:Data>\n';
        headerRow += '  </ss:Cell >\n';
    }

    headerRow += '</ss:Row>\n';
    return (
        '<?xml version="1.0"?>\n' +
        '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
        '<ss:Styles>\n' +
        '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
        '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
        '<ss:Borders>\n' +
        '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="blue"/>\n' +
        '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
        '</ss:Borders>\n' +
        '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
        '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
        '</ss:Style>\n' +
        '</ss:Styles>\n' +
        '<ss:Worksheet ss:Name="Sheet1">\n' +
        '<ss:Table>\n' +
        dataRow +
        '<ss:Row/>\n' +
        headerRow
    );
}